<template>
  <div v-if="!loaded" class="text-center preloader">
    <div class="spinner-border" role="status">
    </div>
    <div>Загрузка страницы...</div>
  </div>
  <div v-if="loaded&&loadError" class="text-center loadError">
    <div class="alert alert-danger" role="alert">
      {{ loadErrorMessage }}
    </div>
    <div class="container">
      <div class="row p-2 justify-content-center">
        <button class="btn btn-primary w-auto" type="button" @click.prevent="loaded=false;lkload()">Повторить попытку
        </button>
      </div>
      <div class="row p-2 justify-content-center">
        <button class="btn btn-primary w-auto" type="button" @click.prevent="reload()">Обновить страницу</button>
      </div>
    </div>
  </div>
  <!-- Registration -->

  <section  class="my-3 login-section" v-if="loaded&!loadError">

    <div class="container py-4" v-if="authenticated">
      <div class="row  justify-content-center">
        <div class="col-md-5 col-lg-4  text-center">
          <div  class="card login-form box-shadow bg-light">
            <div class="card-header bg-light py-3">
              <h4>Вход успешен</h4>
            </div>
            <h4></h4>
            <div class="card-body">
              <div class="mt-2">Выполняется автоматический переход  в личный кабинет. Нажмите на кнопку ниже, если автоматический переход не произошёл.</div>
              <a  :href="redirectUrl"  class="btn btn-sm btn-dark mt-2">Перейти</a>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div  class="container py-4" v-if="!authenticated">
      <div  class="row align-items-top">
        <div  class="col-md-6 text-center" v-html="INIT.hello_html">

        </div>
        <div  class="col-md-6">
          <div  class="row justify-content-center">
            <div  class="col-md-12">
              <div  class="login-form">
                <div  class="card-body">
                  <h5>Вход</h5>
                  <form ref="formRef" @submit.prevent="login();">
                    <div>
                      <input type="hidden" name="login_form[uid]"  v-model="fields.uid.value"/>
                      <input type="hidden" name="login_form[group_id]"  v-model="INIT.group_id"/>
                      <input type="hidden" name="login_form[_csrf]"  v-model="_csrf"/>
                      <input type="hidden" name="login_form[method]"  v-model="loginMode"/>

                      <div class="mb-2" v-if="steep===2&&!fields.isConfirmed.value">
                        <svg class="norm" width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM17 3.5L1 3.5V4.5L17 4.5V3.5Z" fill="#2D2A26"></path>
                          </svg> <a @click.prevent="steep=1;$refs.phone1.focus();sendTimeoutStarted=null" href="#">Сменить указанный номер</a>
                      </div>

                      <div  class="text-nowrap"><input v-if="fields.isConfirmed.value" ref="phone1"  readonly="readonly"  class="form-control form-phone d-inline-block" :placeholder="phonePlaceholder" name="login_form[phone]" v-model="fields.phone.value"  required="required" :class="{ 'is-invalid': !fields.phone.isValid&&fields.phone.wasValidated,'is-valid': fields.phone.isValid&&fields.phone.wasValidated }">
                     <input v-if="!fields.isConfirmed.value" ref="phone1" data-maska-eager type="tel" :readonly="steep===2" @focus="resetValidation();loginInfo.error=''"  v-maska :data-maska="phoneMask" class="form-control form-phone d-inline-block" :placeholder="phonePlaceholder" name="login_form[phone]" v-model="fields.phone.value"  required="required" :class="{ 'is-invalid': !fields.phone.isValid&&fields.phone.wasValidated,'is-valid': fields.phone.isValid&&fields.phone.wasValidated }"><span v-if="!fields.phone.wasValidated" class="zv inputzv">*</span>
                     <div class="invalid-feedback">{{fields.phone.invalidFeedback}}</div>
                      </div>

                      <div v-if="!fields.isConfirmed.value" class="mt-2"><label  class="form-check-label form-check-label-icon"><input @change="$refs.phone1.focus()"  :readonly="formDisabled" v-model="phoneNonRF" type="checkbox" class="form-check-input"> <span class="form-check-icon"></span> Ввести номер не РФ</label></div>
                      </div>
                    <!---->
                     <div  v-if="actual_message" class="alert alert-success fade show fixed-alert"  role="alert">{{actual_message}}</div>
                                    <div v-if="actual_error" class="alert alert-danger fade show fixed-alert" role="alert">
                      {{actual_error}}
                      <div v-if="loginInfo.offer==='registration'&&steep===1" class="mt-1 mb-1"> <button  type="button" @click.prevent="$emit('switch','registration',fields.phone.value)" class="btn btn-md btn-dark">Зарегистрироваться</button></div>
                    </div>

                    <div v-if="loginInfo.isLoading" class="text-center preloader  mt-3">
                      <div class="spinner-border" role="status">
                      </div>
                      <div>Пожалуйста подождите...</div>
                    </div>

                    <div class="mt-3" v-if="steep===1&&!loginInfo.isLoading">
                      <button type="button" @click="getLoginInfo" class="btn btn-large btn-dark">Далее</button>

                      <div class="mt-2">
                      <p v-if="!fields.isConfirmed.value">Хотите присоединиться? <b><a @click.prevent="$emit('switch','registration',fields.phone.value);">Зарегистрироваться</a></b></p>
                      <small   class="mb-1 text-secondary mt-2" v-html="INIT.pdLinks"></small>
</div>
                    </div>

                    <div class="mt-2" v-if="steep===1">
                      <button type="button" @click="doRedirectToLk" v-if="!loginProcess.isLoading" class="btn btn-large btn-outline-dark">Вернуться на портал</button>
                    </div>


                    <div v-if="steep===2">
                      <span v-if="!fields.isConfirmed.value">
                      <div class="mt-2 mb-2 text-secondary">Подтверждение учётной записи<span class="zv">*</span></div>
                       <div class="mb-2" v-for="(methodConfig,methodName)  in loginInfo.accessibleMethods" :key="methodName">
                         <label v-if="methodConfig.showed<=INIT.methods_showed_level"  class="form-check-label form-check-label-icon"><input name="amethod" @change="$refs.lmdc.scrollIntoView();" v-model="loginMode" :value="methodName"  type="radio" class="form-check-input"><span class="form-check-icon"></span><span v-html="methodConfig.buttonHTML"></span></label>
                       </div>
                     <div v-if="INIT.methods_showed_level<INIT.methods_showed_level_max" class="login-method-description mt-3 d-block">
                       <b><a href="/#"  @click.prevent="INIT.methods_showed_level++">Показать другие способы</a></b>
                     </div>

                      <div ref="lmdc" class="login-method-description-container">
                       <div v-if="loginMode==='password'" class="login-method-description mt-3">
                        Введите пароль:
                        <input   required="required" type="password" class="form-control mt-1"    name="login_form[password]"  placeholder="Пароль" :class="{ 'is-invalid': !fields.password.isValid&&fields.password.wasValidated,'is-valid': fields.password.isValid&&fields.password.wasValidated }">
                        <div class="invalid-feedback">{{fields.password.invalidFeedback}}</div>

                      </div>

                       <div v-if="loginMode==='telegram'" class="login-method-description mt-3">
                          Для входа через Telegram нажмите на кнопку <b>&laquo;Перейти в Telegram&raquo;</b>, в приложении Telegram  нажмите &laquo;<b> ЗАПУСТИТЬ</b>&raquo; для запуска бота, вам будет предложено поделиться номером телефона, после получения ответного сообщения об успехе, вернитесь на эту страницу и нажмите <b>&laquo;Войти&raquo;</b>
                          <span v-html="loginInfo.accessibleMethods.telegram.link"></span>
                        </div>

                      <div v-if="loginMode==='whatsapp'" class="login-method-description mt-3 ">
                        Для входа через Whatsapp нажмите на кнопку <b>&laquo;Перейти в Whatsapp&raquo;</b> и отправьте нам предустановленное сообщение, не меняя его текст,  после получения ответного сообщения об успехе, вернитесь на эту страницу и нажмите <b>&laquo;Войти&raquo;</b>
                        <span v-html="loginInfo.accessibleMethods.whatsapp.link"></span>
                      </div>


                          <div v-if="loginMode==='zvonok'" class="login-method-description mt-3 ">
                        Проверьте свой номер телефона и нажмите <b>&laquo;Запросить код&raquo;</b>, в течении минуты вам позвонит робот и продиктует код, далее введите его в поле
                          <div class="form-row mb-3 mt-3">
                            <div class="">
                            <input ref="code" v-maska data-maska="####"  data-maska-eager required="required" type="tel" class="form-control" v-model="fields.code.value"   name="login_form[code]"  placeholder="Код" :class="{ 'is-invalid': !fields.code.isValid&&fields.code.wasValidated,'is-valid': fields.code.isValid&&fields.code.wasValidated }">
                            </div>
                            <div>
                              <button v-if="!sendTimeoutStarted&&!codeIsSending"  type="button" @click.prevent="requestCode('zvonok');"  class="btn btn-sm btn-dark">Запросить код</button>
                            </div>
                        </div>
                        <div class="invalid-feedback">{{fields.code.invalidFeedback}}</div>
                        <div v-if="codeIsSending" class="text-center preloader  mt-3">
                          <div class="spinner-border" role="status">
                          </div>
                          <div>Пожалуйста подождите, идёт проверка данных и отправка кода на номер <br> {{fields.phone.value}}</div>
                        </div>
                        <div v-if="sendTimeoutStarted" class="mt-2">Повторный заказ звонка возможен через {{sendTimeout}} секунд </div>

                        <div v-if="codeSentError" class="alert alert-danger fade show fixed-alert" role="alert">
                          {{codeSentError}}
                        </div>

                        <div class="mb-3">

                        </div>

                      </div>








                      <div v-if="loginMode==='sms'" class="login-method-description mt-3 ">
                        Проверьте свой номер телефона и нажмите <b>&laquo;Запросить код&raquo;</b>, далее введите его в поле
                          <div class="form-row mb-3 mt-3">
                            <div class="">
                            <input ref="code" v-maska data-maska="####"  data-maska-eager required="required" type="tel" class="form-control" v-model="fields.code.value"   name="login_form[code]"  placeholder="Код" :class="{ 'is-invalid': !fields.code.isValid&&fields.code.wasValidated,'is-valid': fields.code.isValid&&fields.code.wasValidated }">
                            </div>
                            <div>
                              <button v-if="!sendTimeoutStarted&&!codeIsSending"  type="button" @click.prevent="requestCode();"  class="btn btn-sm btn-dark">Запросить код</button>
                            </div>
                        </div>
                        <div class="invalid-feedback">{{fields.code.invalidFeedback}}</div>
                        <div v-if="codeIsSending" class="text-center preloader  mt-3">
                          <div class="spinner-border" role="status">
                          </div>
                          <div>Пожалуйста подождите, идёт проверка данных и отправка кода на номер <br> {{fields.phone.value}}</div>
                        </div>
                        <div v-if="sendTimeoutStarted" class="mt-2">Повторная отправка кода возможна через {{sendTimeout}} секунд </div>

                        <div v-if="codeSentError" class="alert alert-danger fade show fixed-alert" role="alert">
                          {{codeSentError}}
                        </div>

                        <div class="mb-3">

                        </div>

                      </div>
                      </div>
                      </span>
                      <div v-if="loginProcess.isLoading" class="text-center preloader  mt-3">
                        <div class="spinner-border" role="status">
                        </div>
                        <div>Пожалуйста подождите...</div>
                      </div>

                      <div class="mt-3" v-if="steep===2">
                        <button type="button" @click="login" v-if="!loginProcess.isLoading" class="btn btn-large btn-dark">Войти</button>
                      </div>


                      <div class="mt-2">
                      <p v-if="!fields.isConfirmed.value">Хотите присоединиться? <b><a @click.prevent="$emit('switch','registration',fields.phone.value);">Зарегистрироваться</a></b></p>

                      <small   class="mb-1 text-secondary mt-2" v-html="INIT.pdLinks"></small>
                      <div  class="mt-2" v-if="steep===2&&!fields.isConfirmed.value">
                        <button type="button" @click="doRedirectToLk" v-if="!loginProcess.isLoading" class="btn btn-large btn-outline-dark">Вернуться на портал</button>
                      </div>
                      </div>

                    </div>

                  </form>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section v-if="loaded&!loadError" class="my-3">
    <div class="container py-4">
     </div>
  </section>
</template>

<script>
import {defineEmits, reactive, ref, watch} from 'vue'
import {request} from "@/api";
import {api_config} from "@/config";
import {vMaska} from "maska"
import {Exception} from "sass";
import {access} from "@babel/core/lib/config/validation/option-assertions";

export default {
  name: "LoginPage",
  methods: {access},
  components: { },
  directives: { maska: vMaska} ,
  props:['reglogin'],
  setup(props,{emit}) {

    const INIT=ref({});
    const steep=ref(1);
    const _csrf=ref('');
    const loginMode=ref('');
    const loadError = ref(false);
    const loadErrorMessage = ref('');
    const codeWasSent = ref(false);
    const codeIsSending = ref(false);
    const formDisabled= ref(false);
    const authenticated= ref(null);
    const loaded = ref(false);
    const phonePlaceholder= ref("+7 (___) ___-__-__");
    const sendTimeout= ref(100);
    const sendTimeoutStarted= ref(null);

    //Последнее  сообщение
    const actual_message= ref('');
    //Последняя ошибка
    const actual_error= ref('');
    defineEmits(['switch']);


    const fields_default={
      phone:{value: props.reglogin,isValid: false,wasValidated: false, invalidFeedback:null},
      code:{value: '',isValid: false, wasValidated: false, invalidFeedback: null },
      password:{value: '',isValid: false, wasValidated: false, invalidFeedback: null },
      uid:{value: ''},
      isConfirmed:{value: false}
    };

 const  phoneField = ref(null);
// eslint-disable-next-line no-unused-vars
const  fields = reactive(fields_default);

const  loginInfo = reactive({loaded: false, isLoading: false, error: '', accessibleMethods:{ },offer:null });

const  loginProcess = reactive({loaded: false, isLoading: false, error: ''});



const  code = ref(null);
const  formRef = ref(null);
const  codeSentError = ref(null);
const  redirectToLkTimeout = ref(10);
const  redirectToLkTimeoutStarted = ref(null);
const redirectUrl=ref('/');


//const  message = ref('');
//const  isSaved = ref(false);


    const reload = () => {
      document.location.reload();
    };

    const codeSendTimeoutRealization=(timeout)=>
    {sendTimeout.value=timeout;
      sendTimeoutStarted.value=setInterval(()=>{sendTimeout.value--; if(sendTimeout.value<=0){clearInterval(sendTimeoutStarted.value); sendTimeoutStarted.value=null;}},1000);
    }

    const doRedirectToLk=()=>
    {
     document.location=redirectUrl.value;
     //alert(redirectUrl.value);
    };


    const redirectToLkTimeoutRealization=(timeout)=>
    {
      redirectToLkTimeout.value=timeout;
      redirectToLkTimeoutStarted.value=setInterval(()=>{ redirectToLkTimeout.value--; if(redirectToLkTimeout.value<=0){clearInterval(redirectToLkTimeoutStarted.value); doRedirectToLk(); }},10000);
    }

    const formEdit=()=>
    {
      formDisabled.value=false;
      codeWasSent.value=false;
    }

    const lkload = (APP_ENV) => {
      try {
        // eslint-disable-next-line no-undef
        if(typeof APP_ENV.login!=="object"){throw new  Exception("Не удалось загрузить информацию");}
        loadError.value = false;
        loaded.value = true;
        loadErrorMessage.value = null;

        if(typeof APP_ENV._csrf!=='undefined'&&APP_ENV._csrf )
        {
          _csrf.value=APP_ENV._csrf;
        }

        if(typeof APP_ENV.redirectUrl!=='undefined')
        {
          redirectUrl.value=APP_ENV.redirectUrl;
        }


        if(typeof APP_ENV.INIT!=='undefined')
        {
          INIT.value= APP_ENV.INIT;
        }

        if(typeof APP_ENV.login.isAuthenticated!=='undefined'&&APP_ENV.login.isAuthenticated )
        {
        authenticated.value=APP_ENV.login.isAuthenticated;
        if(authenticated.value){doRedirectToLk();}
        }else{authenticated.value=null;}


       if(typeof INIT.value.isConfirmed!=='undefined'&&INIT.value.isConfirmed){
         steep.value=2;
         fields.phone.value=INIT.value.DATA.login;
         fields.uid.value=INIT.value.DATA.uid;
         fields.isConfirmed.value=true;
       }


        //**

        //**


      } catch (e) {
        loaded.value = true;
        loadError.value = true;
        loadErrorMessage.value = "Не удалось загрузить информацию. Исключительная ситуация "+e.message;
      }

    }

    const login = ()=>{
     loginProcess.loaded=false;
     loginProcess.isLoading=true;
     loginProcess.error='';
     actual_error.value='';
     actual_message.value='';
          let body=new FormData(formRef.value);
      formDisabled.value=true;
      request('doLogin', {method: 'POST',body: body}, api_config).then(commits => {
      refreshFields(commits.validation_result);
        // eslint-disable-next-line no-empty
        if (commits.success) {
          loginProcess.loaded=true;
          redirectUrl.value=commits.redirectUrl;
         // alert("Вал: "+redirectUrl.value);
        } else {
          formDisabled.value = false;
          loginProcess.error=commits.message;

          actual_error.value=commits.message;

        }

        if(typeof commits.isAuthenticated!=='undefined'&&commits.isAuthenticated){
          authenticated.value=commits.isAuthenticated;
        }


     // eslint-disable-next-line no-unused-vars
      }).catch((e) => {
        console.log(e);
        formDisabled.value = false;
        let msg="Не удалось получить ответ с сервера";
        loginProcess.error=msg
        actual_error.value=msg;
        resetValidation();
      }).finally(()=>{ loginProcess.isLoading=false;});

    };

    // eslint-disable-next-line no-unused-vars
    const refreshFields=(validation_result)=>{
    if(typeof validation_result !=='undefined'&&typeof validation_result==='object') {
      for (let key in fields) {
        if (typeof validation_result[key] !== "undefined") {
          fields[key].wasValidated = true;
          fields[key].isValid = validation_result[key].isValid;
          fields[key].invalidFeedback = validation_result[key].invalidFeedback;
          if (typeof validation_result[key].value !== "undefined") {
            fields[key].value = validation_result[key].value;
          }
        }
      }
    }
    }


    const resetValidation=()=>{
    for (let key in fields)
    {
      fields[key].wasValidated=false;
      fields[key].isValid=false;
      fields[key].invalidFeedback=null;
    }
    }


    const getLoginInfo = ()=>{
      let body=new FormData(formRef.value);
      loginInfo.accessibleMethods={ };
      loginInfo.error='';
      actual_error.value='';
      actual_message.value='';
      loginInfo.isLoading=true;
      loginInfo.loaded=false;
      loginInfo.offer=null;

      resetValidation();
   request('getLoginInfo', {method: 'POST',body: body}, api_config).then(commits => {
        if(typeof commits.isAuthenticated!=='undefined'&&commits.isAuthenticated){
          authenticated.value=commits.isAuthenticated;
        }
        refreshFields(commits.validation_result);
        if (commits.success) {
          loginInfo.loaded=true;
          fields.uid.value=commits.uid;
          loginInfo.accessibleMethods=commits.accessibleMethods;
          steep.value=2;
        } else {
          loginInfo.error = commits.message;
          actual_error.value=commits.message;
           if(typeof commits.offer!=='undefined'){
            loginInfo.offer=commits.offer;
             if(loginInfo.offer){
               emit('switch','registration',fields.phone.value,'Пользователь с таким номером  ещё не зарегистрирован')
             }
          }

        }
        // eslint-disable-next-line no-unused-vars
      }).catch((e) => {
       let msg="Не удалось получить ответ с сервера";
        loginInfo.error =msg;
        actual_error.value=msg;
      }).finally(()=>{loginInfo.isLoading = false;})

    }


   const requestCode = (provider=null)=>{
    let body=new FormData(formRef.value);
    if(provider==='zvonok'){body.append('zvonok','Y');}
    codeSentError.value = null;
    codeWasSent.value = false;
     actual_error.value='';
     actual_message.value='';

    codeIsSending.value = true;
    fields.code.value='';
    formDisabled.value=true;
      request('getLoginCode', {method: 'POST',body: body}, api_config).then(commits => {
        if(typeof commits.isAuthenticated!=='undefined'&&commits.isAuthenticated){
          authenticated.value=commits.isAuthenticated;
        }
 if (commits.success) {
codeWasSent.value = true;
actual_message.value="На номер "+fields.phone.value+" был отправлен код, введите его в поле ниже.";
if(provider==='zvonok'){ actual_message.value="На номер "+fields.phone.value+" в течении минуты поступит звонок, робот продиктует Вам код, введите его в поле ниже.";}
if(code.value){code.value.focus();}
codeSendTimeoutRealization(commits.data.SEND_RETRY_TIMEOUT ?? 100);

        } else {
          formDisabled.value = false;
          codeSentError.value = commits.message;
          actual_error.value=commits.message;
        }
        // eslint-disable-next-line no-unused-vars
      }).catch((e) => {
        console.log(e);
        formDisabled.value = false;
        let msg="Не удалось получить ответ с сервера";
        codeSentError.value = msg;
        actual_error.value=msg;
      }).finally(()=>{codeIsSending.value = false;})
    }

    const phoneNonRF = ref(false);
    const phoneMask = ref("+7 (###) ###-##-##");

    const setLoginMode=(mode)=>{
      loginMode.value=mode;
    }

    // eslint-disable-next-line no-unused-vars
    watch(phoneNonRF, async (newphoneNonRF, oldphoneNonRF) => {
      if(newphoneNonRF)
      {
        phoneMask.value="+###############";
        phonePlaceholder.value="+_______________";
      }else{
        phoneMask.value="+7 (###) ###-##-##";
        phonePlaceholder.value="+7 (___) ___-__-__";

      }
    })

    // eslint-disable-next-line no-unused-vars
    watch(authenticated, async (newVal, oldVal) => {
      if(newVal)
      {
        doRedirectToLk();
      }
    })


    return {
      props,
      actual_message,
      actual_error,
      INIT,
      redirectUrl,
      resetValidation,
      loginProcess,
      getLoginInfo,
      loginInfo,
      steep,
      login,
      requestCode,
      _csrf,
      loginMode,
      setLoginMode,
      doRedirectToLk,
      authenticated,
      reload,
      lkload,
      redirectToLkTimeoutRealization,
      redirectToLkTimeout,
      redirectToLkTimeoutStarted,
      phoneField,
      formEdit,
      codeSentError,
      code,
      formRef,
      formDisabled,
      codeIsSending,
      codeWasSent,
      fields,
      sendTimeoutStarted,
      sendTimeout,
      codeSendTimeoutRealization,
      phonePlaceholder,
      phoneNonRF,
      phoneMask,
      loadErrorMessage,
      loadError,
      loaded,
    }
  },

  beforeMount() {
// eslint-disable-next-line no-undef
    this.lkload(APP_ENV);

  },

  mounted(){

    if(this.props.reglogin) {
      this.fields.phone.value = this.props.reglogin;
      this.$nextTick(() => {
        this.getLoginInfo();
      });

    }

  },



  activated(){
    if(this.props.reglogin) {
      this.fields.phone.value = this.props.reglogin;
      this.$nextTick(() => {
        this.getLoginInfo();
      });

    }
  },




}
</script>
<style scoped>
svg.norm{transform: none;}
a.btn-dark{color: #ffffff;}
.zv{color: red;}
.inputzv{display: inline-block; position: relative; top: -10px;}
.alogin-form input{border: 2px solid #e2e2e2; }
</style>
